import { BASE_URL } from "../constants";

const GET_SELLER_ORDERS = {
  method: "get",
  url: `${BASE_URL}/seller/web/orders/`,
};

const GET_SELLER_RETURN_ORDERS = {
  method: "get",
  url: `${BASE_URL}/seller/web/return/orders/`,
};

const GET_ORDER_DETAILS_BY_ID = {
  method: "get",
  url: `${BASE_URL}/seller/web/order/`,
};

const GET_RETURN_ORDER_DETAILS_BY_ID = {
  method: "get",
  url: `${BASE_URL}/seller/web/return/order/`,
};

const GET_ORDER_SUMMARY = {
  method: "get",
  url: `${BASE_URL}/seller/web/orders_summary/`,
};

const GET_RETURN_ORDER_SUMMARY = {
  method: "get",
  url: `${BASE_URL}/seller/web/return/orders_summary/`,
};

const PATCH_ACCEPT_REJECT_ORDER = {
  method: "patch",
  url: `${BASE_URL}/seller/web/order/`,
};

const PATCH_ACCEPT_SHIP_ORDER = {
  method: "patch",
  url: `${BASE_URL}/seller/web/return/order/`,
};

const PUT_UPDATE_ORDER = {
  method: "put",
  url: `${BASE_URL}/seller/web/order/`,
};

const GET_STOCK_CATEGORIES = {
  method: "get",
  url: `${BASE_URL}/seller/web/categories/`,
};

const POST_SELLER_ADD_STOCK = {
  method: "post",
  url: `${BASE_URL}/seller/sellerproduct/`,
};

const GET_SELLER_PRODUCTS = {
  method: "get",
  url: `${BASE_URL}/seller/web/supplierproduct/v2/`,
};

const POST_CREATE_SELLER_PRODUCT = {
  method: "post",
  url: `${BASE_URL}/seller/web/supplierproduct/v2/`,
};

const V2_POST_CREATE_SELLER_PRODUCT = {
  method: "post",
  url: `${BASE_URL}/seller/web/supplierproduct/v2/`,
};

const PUT_UPDATE_DELETE_SELLER_PRODUCT = {
  method: "put",
  url: `${BASE_URL}/seller/web/supplierproduct/v2/`,
};

const DELETE_SELLER_PRODUCT = {
  method: "delete",
  url: `${BASE_URL}/seller/web/supplierproduct/v2/`,
};

const PATCH_CREATE_SELLER_PRODUCT = {
  method: "patch",
  url: `${BASE_URL}/seller/web/supplierproduct/v2/`,
};

const POST_UPDATE_STOCK_STATUS = {
  method: "post",
  url: `${BASE_URL}/seller/web/update/product/status/`,
};

const GET_SEARCH_STOCK = {
  method: "get",
  url: `${BASE_URL}/seller/web/supplierproductsearch/`,
};

const DOWNLOAD_BULK_ORDERS = {
  method: "post",
  url: `${BASE_URL}/seller/web/orders/pdf/`,
};

const PATCH_BULK_ORDER_STATUS = {
  method: "patch",
  url: `${BASE_URL}/seller/web/orders/update/status/`,
};

const GET_ORDER_SCHEDULE_STATUS = {
  method: "get",
  url: `${BASE_URL}/seller/web/orders/schedule/status/`,
};

const POST_BULK_STOCK = {
  method: "post",
  url: `${BASE_URL}/seller/web/bulkupload/publish/`,
};

const GET_SELLER_LEDGER = {
  method: "get",
  url: `${BASE_URL}/seller/web/ledger/`,
};

const GET_PRODUCTS = {
  method: "get",
  url: `${BASE_URL}/udhaar/web/categories/products/v2/`,
};

const GET_PRODUCTS_BY_BARCODE = {
  method: "get",
  url: `${BASE_URL}/udhaar/web/barcode/search/v2/`,
};

const GET_VARIANT_ATTRIBUTES = {
  method: "get",
  url: `${BASE_URL}/seller/web/getattributes/`,
};

const GET_GENERAL_WALLET_INFO = {
  method: "get",
  url: `${BASE_URL}/rnp/web/wallet/v2/`,
};

const GETWALLETTRANSACTION = {
  method: "post",
  url: `${BASE_URL}/rnp/web/transactions/listing/`,
};

const GETBANKLIST = {
  url: `${BASE_URL}/rnp/web/banks/v3/`,
  method: "get",
};

const TITLEFETCH = {
  url: `${BASE_URL}/rnp/web/titlefetch/`,
  method: "get",
};

const WALLETSENTMONEY = {
  url: `${BASE_URL}/rnp/web/sendmoney/raast/`,
  method: "post",
};

const GETWALLETSENTMONEY = {
  url: `${BASE_URL}/rnp/web/sendmoney/raast/`,
  method: "get",
};

const WALLETRECHARGE = {
  url: `${BASE_URL}/rnp/web/recharge/v3/`,
  method: "post",
};

const WALLETRECHARGETRANSACTION = {
  url: `${BASE_URL}/rnp/web/recharge/`,
  method: "get",
};

const POSTWALLETBILLINQUERY = {
  url: `${BASE_URL}/rnp/web/bill/inquiry/`,
  method: "post",
};

const GETWALLETBILLINQUERY = {
  url: `${BASE_URL}/rnp/web/bill/inquiry/`,
  method: "get",
};
const POSTWALLETBILLPAYMENT = {
  url: `${BASE_URL}/rnp/web/bill/payment/`,
  method: "post",
};
const GETWALLETBILLPAYMENT = {
  url: `${BASE_URL}/rnp/web/bill/payment/`,
  method: "get",
};

const POSTWALLETVOUCHERPAYMENT = {
  url: `${BASE_URL}/rnp/web/vouchers/buy/`,
  method: "post",
};

const GETWALLETVOUCHERPAYMENT = {
  url: `${BASE_URL}/rnp/web/vouchers/buy/`,
  method: "get",
};

const GETBILLLIST = {
  url: `${BASE_URL}/rnp/web/billers/`,
  method: "get",
};
const GETVOCHURELIST = {
  url: `${BASE_URL}/rnp/web/vouchers/available/`,
  method: "get",
};

const REFRESH_TOKEN = {
  url: `${BASE_URL}/accounts/web/token/refresh/`,
  method: "post",
};

const SET_PIN_POST = {
  url: `${BASE_URL}/accounts/web/pin/set/v2/`,
  method: "post",
};
const SET_PIN_GET = {
  url: `${BASE_URL}/accounts/web/pin/set/v2/`,
  method: "get",
};

const CHECK_PIN_GET = {
  url: `${BASE_URL}/accounts/web/check/pin/`,
  method: "post",
};
const POST_PAYMENT_REQUEST = {
  url: `${BASE_URL}/rnp/web/paymentrequest/`,
  method: "post",
};
const POST_TITLE_FETCH = {
  url: `${BASE_URL}/rnp/web/easypaisa/titlefetch/`,
  method: "post",
};
const GET_TITLE_FETCH = {
  url: `${BASE_URL}/rnp/web/easypaisa/titlefetch/`,
  method: "get",
};
const GET_FEEDBACK_QUESTION = {
  url: `${BASE_URL}/engagement/web/feedback/questions/`,
  method: "get",
};
const POST_FEEDBACK_QUESTION = {
  url: `${BASE_URL}/engagement/web/feedback/questions/`,
  method: "post",
};
const POST_UPLOAD_RECEIPT = {
  url: `${BASE_URL}/udhaar/web/upload/receipt/v2/`,
  method: "post",
};
const POST_REPORT_REQUEST = {
  url: `${BASE_URL}/udhaar/web/report-request/v2/`,
  method: "post",
};

const POST_LOGOUT = {
  url: `${BASE_URL}/udhaar/web/logout/v2/`,
  method: "post",
};

const POST_LOGIN = {
  url: `${BASE_URL}/udhaar/web/login/v3/`,
  method: "post",
};

const SELLER_REPORT = {
  url: `${BASE_URL}/seller/web/report/`,
  method: "get",
};

const SELLER_PAYMENT_PDF = {
  url: `${BASE_URL}/seller/web/payment/pdf/`,
  method: "post",
};
const AIRWAY_BILL_INVOICE = {
  url: `${BASE_URL}/seller/web/airway_bill_and_invoice/`,
  method: "post",
};

const PDF_DOWNLOAD = {
  url: `${BASE_URL}/udhaar/web/pdf/v3/`,
  method: "post",
};

const PDF_DOWNLOAD_NEW = {
  url: `${BASE_URL}/udhaar/web/pdf/v3/`,
  method: "post",
};

const GET_ACCOUNT_INFO = {
  url: `${BASE_URL}/rnp/web/walletV5/account_info`,
  method: "get",
};

const BUSINESS_REPORT = {
  url: `${BASE_URL}/udhaar/web/business/report`,
  method: "get",
};

const GET_SHARED_ACCOUNTS = {
  url: `${BASE_URL}/udhaar/web/sharedaccounts/v2/`,
  method: "post",
};

const GET_SHARED_ACCOUNT_PAYMENT = {
  url: `${BASE_URL}/udhaar/web/sharedaccountspayments/v2/`,
  method: "post",
};

const GET_PROFIT_AND_LOSS_OVERVIEW = {
  url: `${BASE_URL}/udhaar/web/profit-loss/overview/`,
  method: "post",
};

const GET_CASH_FLOW_OVERVIEW = {
  url: `${BASE_URL}/udhaar/web/cash-flow/overview/`,
  method: "post",
};

const GET_STOCK_OVERVIEW = {
  url: `${BASE_URL}/udhaar/web/stock/overview/`,
  method: "post",
};

const GET_PNL_STATEMENT = {
  url: `${BASE_URL}/udhaar/web/profit-loss/details/`,
  method: "post",
};

const GET_CASHFLOW_STATEMENT = {
  url: `${BASE_URL}/udhaar/web/cash-flow/details/`,
  method: "post",
};

const PAGINATED_SYNC_API_URL = {
  url: `${BASE_URL}/udhaar/websync/initial/`,
  method: "get",
};

const SYNC_API_URL = {
  url: `${BASE_URL}/udhaar/websync/v3/`,
  method: "get",
};

const POST_SYNC_API_URL = {
  url: `${BASE_URL}/udhaar/websync/v3/`,
  method: "post",
};

const ACCOUNT_PIN_RESET = {
  url: `${BASE_URL}/accounts/web/pin/reset/`,
  method: "get",
};
const POST_ACCOUNT_PIN_RESET = {
  url: `${BASE_URL}/accounts/web/pin/reset/`,
  method: "post",
};

const POST_CAPTCHA = {
  url: `${BASE_URL}/rnp/web/captcha/v2/`,
  method: "post",
};

const PUT_CAPTCHA = {
  url: `${BASE_URL}/rnp/web/captcha/v2/`,
  method: "put",
};

const GET_UNAUTHORIZED_CATEGORIES = {
  url: `${BASE_URL}/udhaar/web/public/configs/v2/`,
  method: "get"
}

const GET_BENEFICIARY_LIST = {
  url: `${BASE_URL}/raast/web/beneficiaries/`,
  method: "get",
};

const GET_WALLET_BALANCE = {
  url: `${BASE_URL}/rnp/web/wallet/mini/v2/`,
  method: "get",
};
const GET_SEARCH_BILL_DETAILS ={
   url : `${BASE_URL}/rnp/billpdf/`,
   method : "post"
}

const GET_BILL_PDF_STATUS = {
   url : `${BASE_URL}/rnp/billpdf/`,
   method : "get"
}

const POST_BILL_DQR = {
   url : `${BASE_URL}/rnp/billdqr/`,
   method : "post"
}

const GET_BILL_DQR_STATUS = {
   url : `${BASE_URL}/rnp/billdqr/`,
   method : "get"
}
const WALLET_GERNERAL_V6 = {
  url: `${BASE_URL}/rnp/web/walletV6/`,
  method: "get",
};

const GET_ACCOUNT_LIMIT = {
  url: `${BASE_URL}/raast/web/transactionlimit/`,
  method: "get",
};
const POST_INCREASE_ACCOUNT_LIMIT = {
  url: `${BASE_URL}/udhaar/web/agent/onboarding/v2/`,
  method: "post",
};

const GET_TRANSACTION_LIST_V2 = {
  url: `${BASE_URL}/rnp/web/transactions/listing/v2/`,
  method: "post",
};

const GET_POPULAR_BILLS = {
  url: `${BASE_URL}/rnp/web/popular/bill/`,
  method: "get",
};

const SEARCH_BILL_CUSTOMER = {
  url: `${BASE_URL}/rnp/web/search/bill/`,
  method: "get",
};
const EXPORTTRANSACTION = {
  url: `${BASE_URL}/rnp/web/transactions/statement/v2/`,
  method: "post",
};
const EXPORTGETSTATEMENT = {
  url: `${BASE_URL}/rnp/web/transactions/statement/v2/`,
  method: "get",
};

const GET_POPULAR_VOUCHERS = {
  url: `${BASE_URL}/rnp/web/popular/voucher/`,
  method: "get",
};

const GET_QR_DETAILS = {
  url: `${BASE_URL}/raast/web/qr-details/`,
  method: "get",
};

const POST_RAAST_REGISTER_ALIAS = {
  url: `${BASE_URL}/raast/web/registeralias/`,
  method: "post",
};

const POST_RAAST_UNLINK_ALIAS = {
  url: `${BASE_URL}/raast/web/unlinkalias/`,
  method: "post",
};

const GET_RAAST_JOB_STATUS = {
  url: `${BASE_URL}/raast/web/jobstatus/`,
  method: "get",
};

const GETSTATEMENTSTATUS = {
  url: `${BASE_URL}/rnp/web/transactions/statement/v3/`,
  method: "get",
};
const RETRYTRANSACTIONSTATEMENT = {
  url: `${BASE_URL}/rnp/web/transactions/statement/v2/`,
  method: "put",
};
const DELETETRANSACTIONSTATEMENT = {
  url: `${BASE_URL}/rnp/web/transactions/statement/v2/`,
  method: "delete",
};

const GET_BILLING_CUSTOMERS_V3 = {
  url: `${BASE_URL}/rnp/web/billingcustomers/v3/`,
  method: "get",
};

const GET_BILLING_CONSUMERS_V4 = {
  url: `${BASE_URL}/rnp/web/billingconsumers/v4/`,
  method: "get",
};

const GET_BILLING_CONSUMER_BILLS = {
  url: `${BASE_URL}/rnp/web/bills/billingconsumer-bills/`,
  method: "get",
};

const GET_VOUCHER_CUSTOMERS_V2 = {
  url: `${BASE_URL}/rnp/web/vouchercustomers/v2/`,
  method: "get",
};

const GET_VOUCHER_VENDORS = {
  url: `${BASE_URL}/rnp/web/customers/vendors/`,
  method: "get",
};

const GET_RECHARGE_CUSTOMERS_V3 = {
  url: `${BASE_URL}/rnp/web/recharge/customers/v3/`,
  method: "get",
};

const UPDATE_CUSTOMER_NAME = {
  url: `${BASE_URL}/rnp/web/update-customer-name/`,
  method: "patch",
};

const GET_TRANSACTION_DETAIL = {
  url: `${BASE_URL}/rnp/web/transaction/detail/`,
  method: "get",
};
const PATCH_UPDATE_TRANSACTION = {
  url: `${BASE_URL}/rnp/web/update-transaction/`,
  method: "patch",
};

const GET_BUSINESS_REPORTS = {
  url: `${BASE_URL}/udhaar/web/reports/`,
  method: "POST",
};

const GET_EMI_STATUS = {
  url: `${BASE_URL}/udhaar/web/emi-status/`,
  method: "get",
}

const DOWNLOAD_REPORT_PDF = {
  url: `${BASE_URL}/udhaar/web/reports/pdf/`,
  method: "post",
}

const GET_AUTHORIZED_CATEGORIES = {
  url: `${BASE_URL}/core/web/categories/`,
  method: "get",
}

const POST_UDHAAR_WIN = (token) => ({
  url: `${BASE_URL}/udhaar/win/${token}/`,
  method: "post",
});

const GET_UDHAAR_WIN = (token) => ({
  url: `${BASE_URL}/udhaar/win/${token}/`,
  method: "get",
});

const SEARCH_RECHARGE_CUSTOMER = {
  url: `${BASE_URL}/rnp/web/search/recharge/customers/`,
  method: "get",
} 

export {
  PUT_UPDATE_DELETE_SELLER_PRODUCT,
  GET_RETURN_ORDER_DETAILS_BY_ID,
  V2_POST_CREATE_SELLER_PRODUCT,
  PATCH_CREATE_SELLER_PRODUCT,
  POST_CREATE_SELLER_PRODUCT,
  GET_ORDER_SCHEDULE_STATUS,
  PATCH_ACCEPT_REJECT_ORDER,
  GET_SELLER_RETURN_ORDERS,
  GET_RETURN_ORDER_SUMMARY,
  PATCH_BULK_ORDER_STATUS,
  PATCH_ACCEPT_SHIP_ORDER,
  GET_ORDER_DETAILS_BY_ID,
  GET_VARIANT_ATTRIBUTES,
  POST_SELLER_ADD_STOCK,
  DELETE_SELLER_PRODUCT,
  DOWNLOAD_BULK_ORDERS,
  GET_STOCK_CATEGORIES,
  GET_SELLER_PRODUCTS,
  GET_SELLER_ORDERS,
  GET_SELLER_LEDGER,
  GET_ORDER_SUMMARY,
  GET_SEARCH_STOCK,
  PUT_UPDATE_ORDER,
  POST_BULK_STOCK,
  GET_PRODUCTS,
  GET_PRODUCTS_BY_BARCODE,
  POST_UPDATE_STOCK_STATUS,
  GET_GENERAL_WALLET_INFO,
  GETWALLETTRANSACTION,
  GETBANKLIST,
  TITLEFETCH,
  WALLETSENTMONEY,
  GETWALLETSENTMONEY,
  WALLETRECHARGE,
  WALLETRECHARGETRANSACTION,
  POSTWALLETBILLINQUERY,
  GETWALLETBILLINQUERY,
  POSTWALLETBILLPAYMENT,
  GETWALLETBILLPAYMENT,
  POSTWALLETVOUCHERPAYMENT,
  GETWALLETVOUCHERPAYMENT,
  GETBILLLIST,
  GETVOCHURELIST,
  REFRESH_TOKEN,
  SET_PIN_POST,
  SET_PIN_GET,
  CHECK_PIN_GET,
  POST_PAYMENT_REQUEST,
  POST_TITLE_FETCH,
  GET_TITLE_FETCH,
  GET_FEEDBACK_QUESTION,
  POST_FEEDBACK_QUESTION,
  POST_UPLOAD_RECEIPT,
  POST_REPORT_REQUEST,
  POST_LOGOUT,
  POST_LOGIN,
  SELLER_REPORT,
  SELLER_PAYMENT_PDF,
  AIRWAY_BILL_INVOICE,
  PDF_DOWNLOAD,
  BUSINESS_REPORT,
  GET_ACCOUNT_INFO,
  GET_SHARED_ACCOUNTS,
  GET_SHARED_ACCOUNT_PAYMENT,
  GET_PROFIT_AND_LOSS_OVERVIEW,
  GET_CASH_FLOW_OVERVIEW,
  GET_STOCK_OVERVIEW,
  GET_PNL_STATEMENT,
  GET_CASHFLOW_STATEMENT,
  PDF_DOWNLOAD_NEW,
  PAGINATED_SYNC_API_URL,
  SYNC_API_URL,
  POST_SYNC_API_URL,
  ACCOUNT_PIN_RESET,
  POST_CAPTCHA,
  PUT_CAPTCHA,
  POST_ACCOUNT_PIN_RESET,
  GET_UNAUTHORIZED_CATEGORIES,
  GET_BENEFICIARY_LIST,
  GET_WALLET_BALANCE,
  WALLET_GERNERAL_V6,
  GET_ACCOUNT_LIMIT,
  POST_INCREASE_ACCOUNT_LIMIT,
  GET_TRANSACTION_LIST_V2,
  GET_BILLING_CUSTOMERS_V3,
  GET_BILLING_CONSUMERS_V4,
  GET_BILLING_CONSUMER_BILLS,
  GET_VOUCHER_CUSTOMERS_V2,
  GET_VOUCHER_VENDORS,
  GET_RECHARGE_CUSTOMERS_V3,
  GET_POPULAR_BILLS,
  SEARCH_BILL_CUSTOMER,
  GET_POPULAR_VOUCHERS,
  EXPORTTRANSACTION,
  GET_QR_DETAILS,
  EXPORTGETSTATEMENT,
  GETSTATEMENTSTATUS,
  RETRYTRANSACTIONSTATEMENT,
  DELETETRANSACTIONSTATEMENT,
  UPDATE_CUSTOMER_NAME,
  GET_TRANSACTION_DETAIL,
  PATCH_UPDATE_TRANSACTION,
  GET_BUSINESS_REPORTS,
  GET_EMI_STATUS,
  DOWNLOAD_REPORT_PDF,
  GET_AUTHORIZED_CATEGORIES,
  GET_SEARCH_BILL_DETAILS,
  GET_BILL_PDF_STATUS,
  POST_BILL_DQR,
  GET_BILL_DQR_STATUS,
  POST_UDHAAR_WIN,
  GET_UDHAAR_WIN,
  SEARCH_RECHARGE_CUSTOMER,
  POST_RAAST_REGISTER_ALIAS,
  POST_RAAST_UNLINK_ALIAS,
  GET_RAAST_JOB_STATUS
};
